import { useParams } from 'quartz-routing/react-router';
export function useDealPlanId() {
  const {
    dealPlanId
  } = useParams();
  if (!dealPlanId || !/^\d+$/.test(dealPlanId)) {
    return undefined;
  }
  return Number(dealPlanId);
}